import {ClassConstructor, ClassTransformer, plainToClass} from 'class-transformer';

export class Mapper extends ClassTransformer {
  toObject<T>(type: ClassConstructor<T>, source: T): T {
    return plainToClass(type, source, {excludeExtraneousValues: true});
  }

  toArray<T>(type: ClassConstructor<T>, source: T[]): T[] {
    return plainToClass(type, source, {excludeExtraneousValues: true});
  }
}
